// extracted by mini-css-extract-plugin
export var button = "_iq-2";
export var card = "_iq-0";
export var closeButtonContainer = "_iq-3";
export var iconContainer = "_iq-1";